import {openLicensesSection} from './adapter';
import {openLicenseUploadModal} from './modal';

/**
 * Canvas licences.
 *
 * A tab on the Canvas Settings page, the way Users and Roles are. It
 * declares no fields, no resolver and no filter: the licence table's
 * search filters only the page it is showing rather than the whole list,
 * so nothing here offers to search it.
 */
const licensePlugin = {
	id: 'license',
	version: 1,
	commandVersion: 1,
	resource: 'license',
	operations: ['options', 'list', 'create'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['settings.dashboard'],
	},
	sections: {
		'settings.licenses': openLicensesSection,
	},
	modals: {
		'license.create': openLicenseUploadModal,
	},
};

export default licensePlugin;
